exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".deep-font-sans * {\n    font-family: 'Inter var', Inter, sans-serif;\n    font-feature-settings: 'ss01', 'cv08', 'calt';\n    overflow-wrap: break-word\n}\n", ""]);

